// BarChart.js
import moment from 'moment';
import * as d3 from 'd3';
import React, { useState, useEffect, useRef } from 'react';
import { Switch, Spinner } from '@blueprintjs/core';

import { RiskItemType, RiskTypes, RiskTypeUnits, ValueType } from './itemDefinitions';
import HierarchyPopover from './HierarchyPopover';
import RomPopupContent from './RomPopupContent';
import { dateFormat } from '../common/dateFormat';

const wrap = (text) => {
  text.each(function () {
    let text = d3.select(this),
      words = text.text().split(/\s+/).reverse(),
      word,
      line = [],
      lineNumber = 0,
      lineHeight = 1.15, // ems
      x = text.attr('x'),
      dx = text.attr('dx'),
      y = text.attr('y'),
      dy0 = 0.31,
      dy = -0.2,
      tspan = text
        .text(null)
        .append('tspan')
        .attr('x', x)
        .attr('dx', dx)
        .attr('y', y)
        .attr('dy', dy + 'em');
    let twidth = text.data()[0].children ? 180 : 300;
    while ((word = words.pop())) {
      line.push(word);
      tspan.text(line.join(' '));
      if (tspan.node().getComputedTextLength() > twidth) {
        line.pop();
        tspan.text(line.join(' '));
        line = [word];
        tspan = text
          .append('tspan')
          .attr('x', x)
          .attr('y', y)
          .attr('dx', dx)
          .attr('dy', ++lineNumber * lineHeight + dy + 'em')
          .text(word);
      }
    }
    if (lineNumber === 0) {
      tspan.attr('dy', dy0 + 'em');
    }
  });
};

// const getAllianceColor = (nData) => {
//   if (!nData.Karaatti_factor) {return '#5C7080'}
//   const colorScheme = ["#002051","#002153","#002255","#002356","#002358","#002459","#00255a","#00255c","#00265d","#00275e","#00275f","#002860","#002961","#002962","#002a63","#002b64","#012b65","#022c65","#032d66","#042d67","#052e67","#052f68","#063069","#073069","#08316a","#09326a","#0b326a","#0c336b","#0d346b","#0e346b","#0f356c","#10366c","#12376c","#13376d","#14386d","#15396d","#17396d","#183a6d","#193b6d","#1a3b6d","#1c3c6e","#1d3d6e","#1e3e6e","#203e6e","#213f6e","#23406e","#24406e","#25416e","#27426e","#28436e","#29436e","#2b446e","#2c456e","#2e456e","#2f466e","#30476e","#32486e","#33486e","#34496e","#364a6e","#374a6e","#394b6e","#3a4c6e","#3b4d6e","#3d4d6e","#3e4e6e","#3f4f6e","#414f6e","#42506e","#43516d","#44526d","#46526d","#47536d","#48546d","#4a546d","#4b556d","#4c566d","#4d576d","#4e576e","#50586e","#51596e","#52596e","#535a6e","#545b6e","#565c6e","#575c6e","#585d6e","#595e6e","#5a5e6e","#5b5f6e","#5c606e","#5d616e","#5e616e","#60626e","#61636f","#62646f","#63646f","#64656f","#65666f","#66666f","#67676f","#686870","#696970","#6a6970","#6b6a70","#6c6b70","#6d6c70","#6d6c71","#6e6d71","#6f6e71","#706f71","#716f71","#727071","#737172","#747172","#757272","#767372","#767472","#777473","#787573","#797673","#7a7773","#7b7774","#7b7874","#7c7974","#7d7a74","#7e7a74","#7f7b75","#807c75","#807d75","#817d75","#827e75","#837f76","#848076","#858076","#858176","#868276","#878376","#888477","#898477","#898577","#8a8677","#8b8777","#8c8777","#8d8877","#8e8978","#8e8a78","#8f8a78","#908b78","#918c78","#928d78","#938e78","#938e78","#948f78","#959078","#969178","#979278","#989278","#999378","#9a9478","#9b9578","#9b9678","#9c9678","#9d9778","#9e9878","#9f9978","#a09a78","#a19a78","#a29b78","#a39c78","#a49d78","#a59e77","#a69e77","#a79f77","#a8a077","#a9a177","#aaa276","#aba376","#aca376","#ada476","#aea575","#afa675","#b0a775","#b2a874","#b3a874","#b4a974","#b5aa73","#b6ab73","#b7ac72","#b8ad72","#baae72","#bbae71","#bcaf71","#bdb070","#beb170","#bfb26f","#c1b36f","#c2b46e","#c3b56d","#c4b56d","#c5b66c","#c7b76c","#c8b86b","#c9b96a","#caba6a","#ccbb69","#cdbc68","#cebc68","#cfbd67","#d1be66","#d2bf66","#d3c065","#d4c164","#d6c263","#d7c363","#d8c462","#d9c561","#dbc660","#dcc660","#ddc75f","#dec85e","#e0c95d","#e1ca5c","#e2cb5c","#e3cc5b","#e4cd5a","#e6ce59","#e7cf58","#e8d058","#e9d157","#ead256","#ebd355","#ecd454","#edd453","#eed553","#f0d652","#f1d751","#f1d850","#f2d950","#f3da4f","#f4db4e","#f5dc4d","#f6dd4d","#f7de4c","#f8df4b","#f8e04b","#f9e14a","#fae249","#fae349","#fbe448","#fbe548","#fce647","#fce746","#fde846","#fde946","#fdea45"]
//   const number = Math.round(nData.Karaatti_factor * colorScheme.length) +1
//   return colorScheme[number]
// }

const getBlockAmountColor = (nData) => {
  if (nData.scope === 'some') {
    return '#0E5A8A';
  }
  if (nData.scope === 'all') {
    return '#5C7080';
  }
  if (nData.scope === 'single') {
    return '#137CBD';
  }
  return '#5C7080';
};

const getRecordTypeColor = (nData) => {
  if (nData.recordType === 'risk') {
    return '#9E2B0E';
  }
  if (nData.recordType === 'opportunity') {
    return '#1F4B99';
  }
  if (nData.recordType === 'neutral') {
    return '#FFE39F';
  }
  return '#5C7080';
};

const itemIsLate = (item) =>
  item.status === 'Resolved'
    ? false
    : moment(item.controlDeadline, dateFormat).isBefore(moment(new Date()));

const getControlColor = (item) =>
  itemIsLate(item) ? '#DB3737' : item.status === 'Resolved' ? '#15B371' : '#137CBD';

const scaleParamByUnit = {
  [RiskTypes.COST]: 800,
  [RiskTypes.ENV]: 300,
  [RiskTypes.WORK_SAFETY]: 0.2,
  [RiskTypes.GEN_SAFETY]: 0.00002,
  [RiskTypes.REPUTATION]: 0.02,
  [RiskTypes.SCHEDULE]: 0.001,
  [RiskTypes.ALLIANCE]: 0.0001,
  [RiskTypes.LIFECYCLE]: 300
};

const CartesianTidyTree = ({
  height,
  width,
  margin,
  data,
  inHeight,
  inWidth,
  valueType,
  dLinks,
  riippuvuudet,
  riskType,
  setActiveNode,
  setMouseEvent,
  setTargetOffset
}) => {
  const ref = useRef();

  const getValue = (nData) => {
    let value;
    switch (valueType) {
      case ValueType.MEDIAN:
        value = nData.calcMedian;
        break;
      case ValueType.P95:
        value = nData.calcP95;
        break;
      case ValueType.EVALUE:
        value = nData.calcEValue;
        break;
      default:
        console.log('wtf');
    }
    return value;
  };

  const formatValue = d3
    .formatLocale({
      decimal: ',',
      thousands: '\u00a0',
      grouping: [3],
      currency: ['', `\u00a0${RiskTypeUnits[riskType]}`]
    })
    .format('$.3~s');

  const getCircleSize = (nData) => {
    return Math.sqrt(Math.abs(getValue(nData)) / scaleParamByUnit[riskType] / Math.PI);
  };

  const handleNodeClick = (e, d) => {
    setActiveNode(d);
    e.preventDefault();
    setMouseEvent(e);
    setTargetOffset({ left: e.clientX, top: e.clientY });
  };

  const draw = () => {
    d3.select(ref.current).selectAll('*').remove();

    const svg = d3
      .select(ref.current)
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', 'translate(' + width / 3 + ',' + height / 2 + '), scale(0.4)');

    const radius = width / 6;
    // Draw L12 goals
    const tree = (data) => {
      const root = d3.hierarchy(data);
      root.dx = 15;
      root.dy = 200;
      return (
        d3
          .tree()
          .nodeSize([root.dx, root.dy])
          // .size([2 * Math.PI, radius])
          .separation((a, b) => {
            return a.parent === b.parent ? 2.4 : 5;
          })(root)
      );
    };
    const root = tree(data);

    const getPathByLink = (link) => {
      const source = root.descendants().find((node) => node.data.technicalId === link.source);
      const target = root.descendants().find((node) => node.data.technicalId === link.target);
      return `
      M${target.y},${target.x}
      C${source.y + root.dy * 4},${target.x}
       ${source.y + root.dy * 4},${source.x}
       ${source.y},${source.x}
    `;
    };

    const getLinksById = (techId) => {
      dLinks.map((link) => link.source === techId || link.target === techId);
    };

    const drawLinksById = (techId) => {
      svg
        .append('g')
        .attr('fill', 'none')
        .selectAll('path')
        .data(getLinksById(techId))
        .join('path')
        .attr('stroke-opacity', 0.4)
        .attr('stroke', '#5C7080')
        .attr('stroke-width', 1.5)
        // .attr(
        //   'd',
        //   d3
        //     .linkRadial()
        //     .angle((d) => d.x)
        //     .radius((d) => d.y)
        // )
        .attr('d', (d) => getPathByLink(d));
    };

    function zoomed({ transform }) {
      paths.attr('transform', transform);
      text.attr('transform', transform);
      valueText.attr('transform', transform);
      calledText.attr('transform', transform);
      calledValueText.attr('transform', transform);
      circles.attr('transform', transform);
      if (riippuvuudet) {
        depLinks.attr('transform', transform);
      }
    }
    svg.call(d3.zoom().scaleExtent([0.1, 8]).on('zoom', zoomed));

    svg
      .append('rect')
      .attr('x', -10 * width)
      .attr('y', -50 * height)
      .attr('width', 20 * width)
      .attr('height', 100 * height)
      .attr('fill-opacity', '0');

    const paths = svg
      .append('g')
      .attr('fill', 'none')
      .selectAll('path')
      .data(() => {
        return root.links(); //.filter((d) => d.source.depth > 0);
      })
      .join('path')
      .attr('stroke-opacity', 0.4)
      .attr('stroke', '#5C7080')
      .attr('stroke-width', 1.5)
      // .attr(
      //   'd',
      //   d3
      //     .linkRadial()
      //     .angle((d) => d.x)
      //     .radius((d) => d.y)
      // )
      .attr(
        'd',
        (d) => `
        M${d.target.y},${d.target.x}
        C${d.source.y + root.dy / 2},${d.target.x}
         ${d.source.y + root.dy / 2},${d.source.x}
         ${d.source.y},${d.source.x}
      `
      );

    const depLinks = riippuvuudet
      ? svg
          .append('g')
          .attr('fill', 'none')
          .selectAll('path')
          .data(dLinks)
          .join('path')
          .attr('stroke-opacity', 0.8)
          .attr('stroke', '#D99E0B')
          .attr('stroke-width', 1.5)
          // .attr(
          //   'd',
          //   d3
          //     .linkRadial()
          //     .angle((d) => d.x)
          //     .radius((d) => d.y)
          // )
          .attr('d', (d) => getPathByLink(d))
      : '';

    const circles = svg
      .append('g')
      .selectAll('circle')
      .data(root.descendants()) //.filter((d) => d.depth > 0))
      .join('circle')
      // .attr(
      //   'transform',
      //   (d) => `
      //     rotate(${(d.x * 180) / Math.PI - 90})
      //     translate(${d.y},0)
      //   `
      // )
      .attr('cx', (d) => d.y)
      .attr('cy', (d) => d.x)
      .attr('fill', (d) => getRecordTypeColor(d.data))
      .on('click', handleNodeClick)
      .style('cursor', 'pointer')
      .attr('r', (d) => getCircleSize(d.data));

    const text = svg
      .append('g')
      .attr('font-family', 'Arial')
      .attr('stroke-linejoin', 'round')
      .attr('stroke-width', 10)
      .selectAll('text')
      .data(root.descendants()) //.filter((d) => d.depth > 0))
      .join('text')
      // .attr('transform', (d) => {
      //   return `
      //   rotate(${(d.x * 180) / Math.PI - 90})
      //   translate(${d.y},0)
      //   rotate(${d.x >= Math.PI ? 180 : 0})
      // `;
      // })
      .attr('x', (d) => (d.x < Math.PI === !d.children ? 6 : -6))
      .attr('x', (d) => d.y)
      .attr('y', (d) => d.x)
      .attr('dy', '0.31em')
      .attr('dx', (d) => (d.children ? -4 - getCircleSize(d.data) : 4 + getCircleSize(d.data))) //(!d.children ? -6 : 6))
      .attr('text-anchor', (d) => (d.children ? 'end' : 'start')) // (d.children ? 'start' : 'end'))
      .text(
        (d) =>
          `${d.data.itemType === RiskItemType.Control ? 'TP ' : ''}${d.data.id}. ${d.data.title}`
      )
      .attr('font-size', (d) => (d.depth < 2 ? 12 : 10))
      .attr('fill', (d) =>
        d.data.itemType === RiskItemType.Control ? getControlColor(d.data) : '#5C7080'
      )
      .on('click', handleNodeClick)
      .style('cursor', 'pointer')
      .style('font-weight', 'bold')
      .attr('font-style', '');

    const valueText = svg
      .append('g')
      .attr('font-family', 'Arial')
      .attr('stroke-linejoin', 'round')
      .attr('stroke-width', 10)
      .selectAll('text')
      .data(root.descendants()) //.filter((d) => d.depth > 0))
      .join('text')
      .attr('x', (d) => d.y)
      .attr('y', (d) => d.x)
      .attr('dx', (d) => (d.children ? '' : -4 - getCircleSize(d.data)))
      .attr('dy', (d) => (d.children ? -8 - getCircleSize(d.data) : '0.31em'))
      .attr('text-anchor', (d) => (d.children ? 'middle' : 'end'))
      .text(
        (d) => `${d.data.itemType === RiskItemType.RBSRisk ? formatValue(getValue(d.data)) : ''}`
      )
      .attr('font-size', (d) => (d.depth < 2 ? 12 : 10))
      .attr('fill', '#5C7080')
      .style('font-weight', 'bold')
      .attr('font-style', '');

    const calledText = text
      .call(wrap)
      .clone(true)
      .lower()
      .attr('stroke', 'white')
      .attr('stroke-width', 4);
    const calledValueText = valueText
      .clone(true)
      .lower()
      .attr('stroke', 'white')
      .attr('stroke-width', 4);
  };

  useEffect(() => {
    draw();
  }, [height, width, data, inHeight, inWidth, valueType]);

  return (
    <div className="chart">
      <svg ref={ref} />
    </div>
  );
};

const RBSItems = ({ itemProps, filterDict }) => {
  const [height, setHeight] = useState(window.innerHeight - 188);
  const [width, setWidth] = useState(window.innerWidth);
  const [riskHierarchy, setRiskHierarchy] = useState();
  const [links, setLinks] = useState([]);
  const [riippuvuudet, setRiippuvuudet] = useState(false);
  const [showControls, setShowControls] = useState(false);

  // Handle node clicks
  const [activeNode, setActiveNode] = useState();
  const [mouseEvent, setMouseEvent] = useState();
  const [targetOffset, setTargetOffset] = useState();

  const margin = { top: 50, right: 30, bottom: 0, left: 50 };
  const inWidth = width - margin.left - margin.right;
  const inHeight = height - margin.top - margin.bottom;

  const itemType = RiskItemType.RBSRisk;

  /** Update the size of the graph element - with a short delay to avoid too many renders */
  const updateGraphSize = () => {
    setTimeout(() => {
      if (height !== window.innerHeight - 188) {
        setHeight(window.innerHeight - 188);
      }
      if (width !== window.innerWidth) {
        setWidth(window.innerWidth);
      }
    }, 200);
  };

  window.addEventListener('resize', updateGraphSize);

  useEffect(() => {
    setRiskHierarchy();
    const allControls = itemProps[RiskItemType.Control].filteredItems;
    const rbsRisks = Object.create(
      itemProps[itemType].filteredItems.filter((item) =>
        item.riskTypes.includes(filterDict.riskType)
      )
    );
    if (rbsRisks && rbsRisks.length > 0) {
      const getChildren = (child) =>
        child.childIds.map((id) =>
          Object.create({
            ...rbsRisks.find((risk) => risk.id === id),
            calcMedian: 0,
            calcEValue: 0,
            calcP95: 0
          })
        );
      const hierarchy = Object.create({
        ...rbsRisks.find((risk) => risk.id === '0'),
        calcMedian: 0,
        calcEValue: 0,
        calcP95: 0
      });
      hierarchy.children = getChildren(hierarchy);
      for (const [i, child] of hierarchy.children.entries()) {
        if (child.childIds.length > 0) {
          child.children = getChildren(child);
        }
      }
      for (const risk of rbsRisks.filter((r) => r.projectPhase !== 0)) {
        let parentFound = false;
        const eValue =
          filterDict.riskType === RiskTypes.COST ? risk.eValue : risk.riskVals[filterDict.riskType];
        for (const [i, child] of hierarchy.children.entries()) {
          if (child.childIds.length > 0) {
            for (const [i2, child2] of child.children.entries()) {
              if (child2.childIds.includes(risk.id)) {
                if (!child2.children) {
                  child2.children = [];
                }
                const calcMedian = risk.median * risk[`${filterDict.currentBlock}_factor`];
                const calcEValue = eValue * risk[`${filterDict.currentBlock}_factor`];
                const calcP95 = risk.p95 * risk[`${filterDict.currentBlock}_factor`];
                let controls = [];
                if (showControls) {
                  controls = allControls.filter((ctrl) =>
                    ctrl.dependencies.includes(risk.technicalId)
                  );
                }

                child2.children.push({
                  ...risk,
                  calcMedian,
                  calcEValue,
                  calcP95,
                  children: controls
                });
                child2.calcMedian += calcMedian;
                child2.calcEValue += calcEValue;
                child2.calcP95 += calcP95;
                child.calcMedian += calcMedian;
                child.calcEValue += calcEValue;
                child.calcP95 += calcP95;
                hierarchy.calcMedian += calcMedian;
                hierarchy.calcEValue += calcEValue;
                hierarchy.calcP95 += calcP95;
                parentFound = true;
              }
            }
          }
        }
        if (!parentFound) {
          const unassigned = hierarchy.children.find((child) => ['X'].includes(child.id));
          if (!unassigned.children) {
            unassigned.children = [];
          }
          const calcMedian = risk.median * risk[`${filterDict.currentBlock}_factor`];
          const calcEValue = eValue * risk[`${filterDict.currentBlock}_factor`];
          const calcP95 = risk.p95 * risk[`${filterDict.currentBlock}_factor`];
          let controls = [];
          if (showControls) {
            controls = allControls.filter((ctrl) => ctrl.dependencies.includes(risk.technicalId));
          }

          unassigned.children.push({
            ...risk,
            calcMedian,
            calcEValue,
            calcP95,
            children: controls
          });
          unassigned.calcMedian += calcMedian;
          unassigned.calcEValue += calcEValue;
          unassigned.calcP95 += calcP95;
          hierarchy.calcMedian += calcMedian;
          hierarchy.calcEValue += calcEValue;
          hierarchy.calcP95 += calcP95;
        }
      }
      setRiskHierarchy(hierarchy);
      const risks = Object.create(
        itemProps[itemType].filteredItems
          .filter((risk) => risk.technicalId !== '0')
          .filter((item) => item.riskTypes.includes(filterDict.riskType))
      );
      if (risks && risks.length > 0) {
        let newLinks = [];
        const riskTechIds = risks.map((risk) => risk.technicalId);
        for (const risk of risks) {
          newLinks = newLinks.concat(
            risk.dependencies
              .filter((dep) => riskTechIds.includes(dep))
              .map((dep) => ({ source: risk.technicalId, target: dep }))
          );
        }
        setLinks(newLinks);
      }
    }
  }, [
    itemProps[itemType].filteredItems,
    filterDict.kvPhase,
    filterDict.currentBlock,
    showControls
  ]);

  const chartProps = {
    height,
    width,
    margin,
    inHeight,
    inWidth,
    setActiveNode,
    setMouseEvent,
    setTargetOffset
  };

  if (!riskHierarchy) {
    return (
      <div>
        <Spinner className="centered" size={100} />
      </div>
    );
  }

  return (
    <div>
      <HierarchyPopover
        node={activeNode}
        mouseEvent={mouseEvent}
        setMouseEvent={setMouseEvent}
        targetOffset={targetOffset}
        content={
          activeNode ? (
            <RomPopupContent
              item={activeNode.data}
              filteredItems={itemProps[itemType].filteredItems.filter((item) =>
                item.riskTypes.includes(filterDict.riskType)
              )}
              hideChildren
            />
          ) : (
            ''
          )
        }
      />
      <Switch
        key="1"
        label="Näytä riippuvuudet"
        checked={riippuvuudet}
        onChange={() => {
          setRiippuvuudet(!riippuvuudet);
        }}
        inline
        alignIndicator="left"
      />
      <Switch
        key="2"
        label="Näytä toimenpiteet"
        checked={showControls}
        onChange={() => {
          setShowControls(!showControls);
        }}
        inline
        alignIndicator="left"
      />
      <CartesianTidyTree
        {...chartProps}
        data={riskHierarchy}
        valueType={filterDict.valueType}
        dLinks={links}
        riippuvuudet={riippuvuudet}
        riskType={filterDict.riskType}
      />
      <p style={{ color: '#5C7080' }}>
        {`Päivitetty ${
          itemProps[itemType].filteredItems.length > 0 && itemProps[itemType].filteredItems[0].date
            ? itemProps[itemType].filteredItems[0].date
            : ''
        }. `}
        Huom. esitetyt mediaani- ja p95-luvut ovat viitteellisiä. Vanha jaottelu löytyy{' '}
        <a href="https://kapa-front.vercel.app/rbs" target="_blank" rel="noopener noreferrer">
          täältä
        </a>
        .
      </p>
    </div>
  );
};

export default RBSItems;
